var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"view-spinner",attrs:{"role":"img","title":"Loading...","viewBox":_vm.viewBox,"width":this.width + 'px',"height":this.width + 'px'}},[_c('circle',{staticClass:"view-spinner-circle",attrs:{"cx":_vm.circlePosition,"cy":_vm.circlePosition,"r":_vm.radius,"stroke-width":_vm.strokeWidthValue}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22962786","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/Spinner.vue
// module id = 415
// module chunks = 0